import React from 'react';

export default function P({ props }) {
    return <hr {...props} />;
}
